import React, {useState, useEffect} from "react";
import axiosInstances from "../../components/axiosInstance";
import { useParams} from "react-router-dom"; 
import Wrapper from "../../components/Wrapper";

 
 

const Test = ()=>{
     const [winners, setWinners ] = useState([]);
   
 

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axiosInstances.read.get(`setWins`);
                 
                 setWinners(data);
           
                 console.log(data);
             }
             )();
        },[id]);
       
    
 
    return (
        <Wrapper pageTitle={"Activation Stats"}>
         
            <div  className="bg-white p-4 rounded-lg shadow-md">
         
 
                    <li className="bg-white p-4 rounded-lg  flex">
                    <div className="w-3/4 pl-4">
                            <div className="text-gray-600 text-sm mb-2"> Requests </div>
                            <h2 className="text-lg font-semibold mb-2">{winners.length}</h2>
                           
                            
                        </div>
                        <div className="w-3/4 pl-4">
                            <div className="text-gray-600 text-sm mb-2">  Subscriptions </div>
                            <h2 className="text-lg font-semibold mb-2">{winners.length}</h2>
                           
                            
                        </div>
                    </li>
                    
                

            </div>
         </Wrapper>
     );
};
export default Test;